import { BaseRetorikConfig } from "../configs/retorikConfig";
import { DirectLineActivity } from "botframework-webchat-core";
import { Dialog } from "../utils/dialog";
import { sendActivity, UpdateActivityCounter } from "../utils/globalUtils";

const methodsToOverrideForSpeechReturn = ["keyboard", "imBack"];

const botEventHandler: Function = (action: any) => {
  console.log("Action : ", action);
  if (!action) {
    return false;
  }

  //connect
  if (action.type == "DIRECT_LINE/CONNECT") {
    action.payload.userID = localStorage.getItem("username")!;
    action.payload.username = localStorage.getItem("username")!;
  }

  let retreiveHistory: boolean = localStorage.getItem("retreiveHistory")
    ? (JSON.parse(localStorage.getItem("retreiveHistory")!) as boolean)
    : false;
  let username = "";
  let dateStart = new Date();

  if (action.type === "DIRECT_LINE/POST_ACTIVITY") {
    //Increment counter activity
    UpdateActivityCounter("+");
  }
  if (action.type === "DIRECT_LINE/POST_ACTIVITY_FULFILLED") {
    //Decrement counter activity
    UpdateActivityCounter("-");
  }

  //Existing user ?
  if (
    action.type == "WEB_CHAT/SET_LANGUAGE" &&
    localStorage.getItem("username") &&
    retreiveHistory
  ) {
    username = localStorage.getItem("username")!;
    BaseRetorikConfig.userData.name = username;
    BaseRetorikConfig.userData.username = username;
    BaseRetorikConfig.userData.id = username;
  }

  if (action.type == "DIRECT_LINE/CONNECT" && retreiveHistory) {
    action.payload.userID = username;
    action.payload.username = username;
    //Inject conversation ID
    action.payload.directLine.conversationId =
      localStorage.getItem("conversationID")!;
  }

  //At first connexion, reset localstorage
  if (action.type == "DIRECT_LINE/CONNECT_FULFILLED") {
    if (!retreiveHistory) {
      username = BaseRetorikConfig.userData.name;
      if (localStorage.getItem("username") != null) {
        username = localStorage.getItem("username")!;
      }

      localStorage.clear();

      localStorage.setItem("username", username);

      let dateStart = new Date();
      localStorage.setItem("dateStart", JSON.stringify(dateStart));
      localStorage.setItem(
        "conversationID",
        action.payload.directLine.conversationId
      );
      localStorage.setItem("retreiveHistory", JSON.stringify(false));
      let CHUEvent_StartSession = new CustomEvent("CHUEvent", {
        detail: {
          name: "CHU_Event_SetConversationId",
          data: action.payload.directLine.conversationId,
        },
      });
      document.dispatchEvent(CHUEvent_StartSession);
    }
  }

  //Catch Set User for retreive history
  if (
    action.type == "WEB_CHAT/SEND_EVENT" &&
    action.payload.name == "setUser"
  ) {
    console.log(retreiveHistory);
    if (retreiveHistory) {
      action.payload.value.user = BaseRetorikConfig.userData;
      action.payload.value.retreiveHistory = true;
      action.payload.value.retreiveHistoryEvents = true;
    }
  }

  //Hack
  if (
    action.type === "DIRECT_LINE/POST_ACTIVITY" &&
    (action.payload?.activity?.channelData === undefined ||
      action.payload?.activity?.channelData?.postBack) &&
    methodsToOverrideForSpeechReturn.includes(action.meta?.method)
  ) {
    action.meta.method = "speech";
  }

  //Trigger form after setUser fullfilled
  if (
    action.type == "DIRECT_LINE/POST_ACTIVITY_FULFILLED" &&
    action.payload.activity.type == "event" &&
    action.payload.activity.name == "setUser"
  ) {
    //Reset activity count
    UpdateActivityCounter("reset");

    //Start timer
    let CHUEvent = new CustomEvent("CHUEvent", {
      detail: {
        name: "StartTimer",
        value: "Conversation",
      },
    });
    document.dispatchEvent(CHUEvent);

    if (!retreiveHistory) {
      let CHUEvent_StartSession = new CustomEvent("CHUEvent", {
        detail: {
          name: "CHU_Event_StartSession",
        },
      });
      document.dispatchEvent(CHUEvent_StartSession);
    }

    /*sendActivity({
        type:"event",
        name: 'StartFormEvent',
        value: {
              "type": 0,
              "formId": "Collecte des données apprenant",
              //"formId": "Formulaire test",
              //"formId" : "Test selection environnement",
              "sectionId": "0"
        }
      });*/
  }

  if (action.type == "DIRECT_LINE/POST_ACTIVITY_FULFILLED") {
    if (
      action.payload.activity.type == "event" &&
      action.payload.activity.name == "continueDialog" &&
      action.payload.activity.value != "voiceFinish" &&
      localStorage.getItem("ButtonInfo") != null
    ) {
      console.log("Remove button if present");
      document.getElementById("Button_Container")?.remove();
      localStorage.removeItem("WaitForNextButton");
      localStorage.removeItem("ButtonInfo");
    }
  }
  /* const SET_SUGGESTED_ACTIONS = "WEB_CHAT/SET_SUGGESTED_ACTIONS";
  if (action.type == "WEB_CHAT/SET_SUGGESTED_ACTIONS") {
    //retrieve suggestedAction from storage
    let suggestedAction = localStorage.getItem("suggestedAction");
    console.log("suggestedAction", suggestedAction);
    //clear storage
    localStorage.removeItem("suggestedAction");
    if (suggestedAction) {
      action.payload.suggestedActions = JSON.parse(suggestedAction);
    }
  }*/

  if (action.type == "DIRECT_LINE/INCOMING_ACTIVITY") {
    //hack for suggestedAction
    /*if (action.payload.activity.suggestedActions) {
      
      //save suggestedACtion to storage
      localStorage.setItem(
        "suggestedAction",
        JSON.stringify(action.payload.activity.suggestedActions)
      );
    }*/

    //retreive conversation read only last message
    if (retreiveHistory && action.payload.activity.type == "message") {
      if (!action.payload.activity.lastMessage) {
        return true;
      } else {
        //History retreived
        localStorage.setItem("retreiveHistory", JSON.stringify(false));
        retreiveHistory = false;
      }
    }

    //events
    if (
      action.payload.activity.type == "event" &&
      action.payload.activity.name
    ) {
      if (action.payload.activity.name.indexOf("CHU_Event") > -1) {
        const CHUEvent = new CustomEvent("CHUEvent", {
          detail: action.payload.activity,
        });
        document.dispatchEvent(CHUEvent);
      }
      if (
        action.payload.activity.type == "event" &&
        action.payload.activity.name == "continueDialog"
      ) {
        /*document.getElementById("Button_Container")?.remove();
          localStorage.removeItem("WaitForNextButton");*/
        localStorage.setItem("ButtonInfo", action.payload.activity.id);
      }
    }

    //Hack for radio reset
    if (action.payload.activity.type == "message") {
      document
        .querySelectorAll("#retorik-botResponse input[type='radio']")
        .forEach((element: Element) => {
          let input = element as HTMLInputElement;
          input.checked = false;
        });
    }

    if (
      action.payload.activity.type == "event" &&
      action.payload.activity.name == "CHU_Event_Timer"
    ) {
      action.payload.activity.meta = {};
      action.payload.activity.meta.timer = action.payload.activity.value;
    }

    if (action.payload.activity.meta) {
      let meta = action.payload.activity.meta;

      //Gestion choix voix
      if (meta?.setVoice) {
        let CHUEvent = new CustomEvent("CHUEvent", {
          detail: {
            name: "CHU_Event_setVoice",
            value: meta?.setVoice,
          },
        });
        document.dispatchEvent(CHUEvent);
      }

      //Gestion Voice
      if (meta?.WaitForVoiceFinish && meta?.WaitForVoiceFinish == "true") {
        localStorage.setItem("WaitForVoiceFinish", action.payload.activity.id);

        console.log("Remove old button if present");
        //Remove old button if exist
        localStorage.removeItem("ButtonInfo");
        document.getElementById("Button_Container")?.remove();
      }
      if (meta?.WaitForNextButton && meta?.WaitForNextButton == "true") {
        localStorage.setItem("WaitForNextButton", action.payload.activity.id);

        console.log("Remove old button if present");
        //Remove old button if exist
        localStorage.removeItem("ButtonInfo");
        document.getElementById("Button_Container")?.remove();

        //Append Button
        let btn_container = document.createElement("div");
        btn_container.className =
          "rounded bg-black bg-opacity-card text-white flex flex-wrap justify-around gap-3 overflow-y-auto w-full max-h-full scrollbar-thin";
        btn_container.style.order = "9";
        btn_container.style.overflow = "initial";
        btn_container.style.marginTop = "10px";
        btn_container.style.padding = "0.5rem";
        btn_container.id = "Button_Container";

        let btn = document.createElement("button");
        if (
          meta?.WaitForNextButtonName &&
          meta?.WaitForNextButtonName.length > 0
        ) {
          btn.innerHTML = meta?.WaitForNextButtonName;
        } else {
          btn.innerHTML = "Suivant";
        }
        btn.id = "Button_WaitForNextButton";
        btn.style.width = "100%";
        btn.style.margin = "0px";
        btn.className =
          "bg-primary flex justify-self-center self-center text-black rounded p-3 m-auto mt-2 mb-2";

        btn.onclick = () => {
          sendActivity({
            type: "event",
            name: "continueDialog",
          });
          //localStorage.removeItem("WaitForNextButton");
        };
        btn_container.append(btn);
        document.getElementById("retorik-botResponse")?.append(btn_container);
        console.log("Add next button");
      }

      //Gestion Animation
      if (
        meta?.animationQueue &&
        meta?.animationQueue.length > 0 &&
        Array.isArray(meta?.animationQueue)
      ) {
        changeAnimation(meta?.animationQueue);
      }

      //Gestion disposition via Meta
      if (meta?.disposition) {
        let CHUEvent = new CustomEvent("CHUEvent", {
          detail: {
            name: "CHU_Event_changeDisposition",
            value: meta?.disposition,
          },
        });
        document.dispatchEvent(CHUEvent);
      }

      //Timer
      if (meta?.timer) {
        /*
          Type : start, pause, resume, retreive
          Name
          */
        console.log(meta?.timer);
        let eventName = "start";
        switch (meta?.timer?.type) {
          case "start":
            eventName = "StartTimer";
            break;
          case "pause":
            eventName = "PauseTimer";
            break;
          case "resume":
            eventName = "ResumeTimer";
            break;
          case "retreive":
            eventName = "RetreiveTimer";
            break;

          default:
            break;
        }
        let CHUEvent = new CustomEvent("CHUEvent", {
          detail: {
            name: eventName,
            value: meta?.timer?.name,
          },
        });
        document.dispatchEvent(CHUEvent);
      }

      //pdf
      if (meta?.pdf && meta?.pdf?.url) {
        let CHUEvent = new CustomEvent("CHUEvent", {
          detail: {
            name: "OpenPDF",
            value: { url: meta?.pdf?.url },
          },
        });
        document.dispatchEvent(CHUEvent);
      }
    }

    //Handle input hint
    if (
      action.payload.activity.inputHint &&
      action.payload.activity.inputHint == "expectingInput"
    ) {
      action.payload.activity.inputHint = "acceptingInput";
    }
  }

  //Gestion des activités attendant la fin de speak pour passer a la suivante
  if (action.type == "WEB_CHAT/MARK_ACTIVITY") {
    let storedVoiceActivity = localStorage.getItem("WaitForVoiceFinish");
    let storedButtonActivity = localStorage.getItem("WaitForNextButton");
    if (
      storedVoiceActivity &&
      action.payload.activityID == storedVoiceActivity &&
      action.payload.name == "speak" &&
      action.payload.value == false
    ) {
      localStorage.removeItem("WaitForVoiceFinish");

      sendActivity({
        type: "event",
        name: "continueDialog",
        value: storedButtonActivity == storedVoiceActivity ? "" : "voiceFinish",
      });
    }
  }

  //Return false to continue store process
  return false;
};

const changeAnimation = (queue: Array<string>) => {
  console.log("Dispatch animation queue", queue);
  const sendAnimationEvent = new CustomEvent("sendPlayAnimationEvent", {
    detail: {
      queue: queue,
    },
  });
  const sendAnimationEvent_internal = new CustomEvent("CHUEvent", {
    detail: {
      name: "animation",
      queue: queue,
    },
  });

  document.dispatchEvent(sendAnimationEvent);
  document.dispatchEvent(sendAnimationEvent_internal);
};

export { botEventHandler, changeAnimation };
